import React from 'react';
import UserManagement from './UserManagement';

const UnifiedUserManagement = ({ users, roles, currentUser, onUpdate, showFeedback }) => {
  return (
    <UserManagement
      users={users}
      roles={roles}
      currentUser={currentUser}
      onUpdate={onUpdate}
      showFeedback={showFeedback}
    />
  );
};

export default UnifiedUserManagement;